/**
 * プラン詳細画面のグロッサリIDの型定義
 *
 * IDの先頭5桁（GL00x）は同一ファイル内では同じものを使用し、グロッサリファイル間では一意とする。
 * それ以降の5桁はファイル内でIDが被らないように採番する。
 */
export const PlanDetailGL = {
  /** プラン詳細 */
  DetailTitle: 'GL00400001',
  /** 価格 */
  PriceTitle: 'GL00400002',
  /** 月 */
  Month: 'GL00400003',
  /** 年 */
  Year: 'GL00400004',
  /** なし */
  None: 'GL00400005',
  /** 購入する */
  Purchase: 'GL00400006',
  /** 詳細 */
  Details: 'GL00400007',
  /** ※ Note ---------- */
  Note1: 'GL00400008',
  /** ※ Note ---------- */
  Note2: 'GL00400009',
  /** 金額・サブスクリプションラベル */
  SubscriptionPrice: 'GL00400010',
  /** プラン1件取得でエラー */
  OtherError: 'GL00400011',
  /** 利用上限 : {0} 回 */
  UsageLimit: 'GL00400012',
  /** 有効期限 : {0} 日 */
  PerpetualValidityPeriod: 'GL00400013',
  /** 関連リンクを見る */
  SeeRelatedLinks: 'GL00400014',
  /** 国・地域の指定がないためプランを表示できません。Canon IDでログインまたは国・地域を選択してください。 */
  NotSelectedCountry: 'GL00400015',
  /** お探しのプランは、現在販売していないか、ご指定の国・地域で販売していません。 */
  NotFoundError: 'GL00400016'
};
export type PlanDetailGLKeys = typeof PlanDetailGL[keyof typeof PlanDetailGL];
